export const blockIconsBusinessandpaymentsAnalyticsNew = (
	<span className='material-symbols-outlined'>analytics</span>
);
